<div class="page">
  <simple-map [mapMode]="'tracking'"></simple-map>
</div>
